export const SUB_CATEGORY = {
  FAIL_FETCH: "SUB_CATEGORY_FAIL_FETCH",
  SUCCESS_FETCH: "SUB_CATEGORY_SUCCESS_FETCH",
};
